import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import Catalog from './pages/Catalog';
import Certificates from './pages/Certificates';
import About from './pages/About';
import States from './pages/States';
import Training from './pages/Training';
import Actividades from './pages/Actividades';
import Explore from './pages/Explore';
import StickyCapacitate from './components/HomePromo';
import StickyPNA from './components/HomePromoPNA';
import StickyTUMB from './components/HomePromoTUM';
import Transparencia from './pages/Transparencia';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";

import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminCertificados from './pages/admin/AdminCertificados';
import AdminCargaMasiva from './pages/admin/AdminCargaMasiva';
import AdminFotos from './pages/admin/AdminFotos';
import AdminLog from './pages/admin/AdminLog';

// Imports de logos para el AdminHeader
import logoCRM from './assets/logos/cruz-roja-logo.png';
import logoCapa from './assets/logos/capacitacion-logo.png';

function AdminRoute({ children }) {
  const token = localStorage.getItem("admin_token");
  if (!token) return <Navigate to="/admin" replace />;
  return children;
}

// Componente AdminHeader para mostrar logos en rutas de administración
function AdminHeader() {
  return (
    <div style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      backgroundColor: "white",
      padding: "10px 0",
      height: "60px",
      position: "sticky",
      top: 0,
      zIndex: 1000,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
    }}>
      <img src={logoCRM} alt="Cruz Roja" style={{ height: "60px", marginLeft: "10px" }} />
      <img src={logoCapa} alt="Capacitación" style={{ height: "60px", marginRight: "20px" }} />
    </div>
  );
}

function AppContent() {
  const location = useLocation();
  const esAdmin = location.pathname.startsWith("/admin");

  return (
    <>
      {!esAdmin && <Navbar />}
      {esAdmin && <AdminHeader />}
      {!esAdmin && <StickyTUMB />}
      {!esAdmin && <StickyPNA />}
      {!esAdmin && <StickyCapacitate />}

      <Routes>
        {/* Rutas públicas */}
        <Route path="/" element={<HomePage />} />
        <Route path="/Catalogo" element={<Catalog />} />
        <Route path="/Sedes" element={<States />} />
        <Route path="/Certificados" element={<Certificates />} />
        <Route path="/Nosotros" element={<About />} />
        <Route path="/Actividades" element={<Actividades />} />
        <Route path="/Plataforma" element={<Training />} />
        <Route path="/Transparencia" element={<Transparencia />} />
        <Route path="/Aprende+" element={<Explore />} />

        {/* Rutas de administración */}
        <Route path="/admin" element={
          localStorage.getItem("admin_token")
            ? <Navigate to="/admin/dashboard" replace />
            : <AdminLogin onLogin={() => window.location.href = "/admin/dashboard"} />
        } />
        <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
        <Route path="/admin/certificados/:tipo" element={<AdminRoute><AdminCertificados /></AdminRoute>} />
        <Route path="/admin/carga-masiva" element={<AdminRoute><AdminCargaMasiva /></AdminRoute>} />
        <Route path="/admin/fotos" element={<AdminRoute><AdminFotos /></AdminRoute>} />
        <Route path="/admin/log" element={<AdminRoute><AdminLog /></AdminRoute>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <Router>
        <AppContent />
      </Router>
    </div>
  );
}

export default App;